import React from 'react';
import { searchResultAvatarClassName } from '../../../utils/avatarClassNames';

const typeLabel = (type) => (type === 'team' ? 'Team' : 'Player');

const HeaderSearchResultsList = ({
	id,
	results,
	isLoading,
	hasSearched,
	query,
	activeIndex,
	onSelect,
	onHover
}) => {
	return (
		<div
			id={id}
			className="absolute bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border mt-2 p-2 rounded-md shadow-lg z-30 max-h-72 overflow-y-auto w-64 sm:w-72 md:w-80"
			style={{ top: '50px', left: '30px' }}
			role="listbox"
			aria-label="Search results"
		>
			{isLoading && (
				<div className="px-2 py-3 text-sm text-gray-500 dark:text-gray-300">
					Searching...
				</div>
			)}

			{!isLoading && hasSearched && results.length === 0 && (
				<div className="px-2 py-3 text-sm text-gray-500 dark:text-gray-300">
					No matches for “{query}”
				</div>
			)}

			{!isLoading && results.length > 0 && (
				<ul>
					{results.map((result, index) => {
						const isActive = index === activeIndex;

						return (
							<li
								key={`${result.type}-${result.id}`}
								role="option"
								aria-selected={isActive}
								className={`p-2 cursor-pointer flex items-center gap-2 rounded-md text-gray-900 dark:text-dark-text ${
									isActive
										? 'bg-gray-100 dark:bg-dark-bg'
										: 'hover:bg-gray-100 dark:hover:bg-dark-bg'
								}`}
								onMouseEnter={() => onHover(index)}
								onClick={() => onSelect(result)}
							>
								<div className="hidden sm:block shrink-0">
									<img
										className={searchResultAvatarClassName}
										src={`${result.image_url}?w=50&h=50`}
										alt=""
										style={{
											width: 40,
											height: 40,
											objectFit: 'cover'
										}}
									/>
								</div>
								<div className="min-w-0 flex-1 flex flex-col justify-center">
									<div className="hover:underline text-xs md:text-sm truncate">
										{result.label}
									</div>
									{result.type === 'player' && result.subtitle && (
										<div className="text-[11px] md:text-xs text-gray-500 dark:text-gray-400 truncate">
											{result.subtitle}
										</div>
									)}
								</div>
								<span className="shrink-0 text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500">
									{typeLabel(result.type)}
								</span>
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
};

export default HeaderSearchResultsList;
